import React, { useEffect, useState } from "react";
import Banner from "./Banner";
import Footer from "./Footer";
import Nav from "./Nav";
import QuickView from "./QuickView";
import Row from "./Row";
import { useAuth } from "../context/AuthContext";
import { fetchBrowseFeed } from "../services/streamApi";

function CatalogPage({ type, pageTitle, pageDescription }) {
  const { user } = useAuth();
  const [feed, setFeed] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedTitle, setSelectedTitle] = useState(null);

  useEffect(() => {
    let active = true;

    async function loadBrowseFeed() {
      try {
        setLoading(true);
        const data = await fetchBrowseFeed({
          type,
          userId: user?.userId,
        });
        if (!active) return;
        setFeed(data);
      } catch (error) {
        console.error("Erreur chargement catalogue:", error);
      } finally {
        if (active) setLoading(false);
      }
    }

    loadBrowseFeed();
    return () => {
      active = false;
    };
  }, [type, user?.userId]);

  return (
    <div className="app-shell">
      <Nav />
      <Banner
        featuredItem={feed?.featured}
        onMoreInfo={setSelectedTitle}
        eyebrow={feed?.featured?.heroContextLabel || pageTitle}
        isLoading={loading}
      />

      <main className="browse-page">
        <section className="browse-page__intro">
          <p className="browse-page__eyebrow">{pageTitle}</p>
          <h1>{pageTitle}</h1>
          <p>{pageDescription}</p>
        </section>

        {loading ? (
          <section className="page-placeholder">
            <div className="page-placeholder__row" />
            <div className="page-placeholder__row" />
          </section>
        ) : (
          feed?.rows?.map((row) => (
            <Row
              key={row.id}
              title={row.title}
              subtitle={row.subtitle}
              items={row.items}
              onMoreInfo={setSelectedTitle}
            />
          ))
        )}
      </main>

      <Footer />
      <QuickView movie={selectedTitle} popup={() => setSelectedTitle(null)} popupStatut={Boolean(selectedTitle)} />
    </div>
  );
}

export default CatalogPage;
